"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Badge = exports.StyledBadge = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styleTokens = require("./shared/styleTokens");

var _templateObject;

var StyledBadge = _styledComponents.default.span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n\tborder-radius: 4px;\n\tcolor: ", ";\n\tpadding: 4px 8px;\n\tbackground-color: ", ";\n"])), _styleTokens.COLOR.white, function (props) {
  switch (props.color) {
    case 'green':
      return _styleTokens.COLOR.green;

    case 'orange':
      return _styleTokens.COLOR.orange;

    case 'red':
      return _styleTokens.COLOR.redLight;

    case 'grey':
      return _styleTokens.COLOR.grey;

    default:
      return props.color;
  }
});

exports.StyledBadge = StyledBadge;

var Badge = function Badge(_ref) {
  var color = _ref.color,
      label = _ref.label,
      value = _ref.value;
  return /*#__PURE__*/_react.default.createElement(StyledBadge, {
    value: value,
    color: color
  }, label);
};

exports.Badge = Badge;